import React from 'react';

class SongListHeadings extends React.Component {
	render () {
		return (
			<div className="grid-x align-justify align-middle song-header-row">
				<div className="cell small-4">
					<strong>Title</strong>
				</div>

				<div className="cell small-4">
					<strong>Album(s)</strong>
				</div>

				<div className="cell small-1 text-center">
					<strong>Time</strong>
				</div>

				<div className="cell small-1 text-center">
					<strong>Explicit</strong>
				</div>

				<div className="cell small-1 text-center">
					<strong>Plays</strong>
				</div>

				<div className="cell small-1 text-center">
					<strong>Hi Fives</strong>
				</div>
			</div>
		);
	}
}

export default SongListHeadings;
